<main class="container-fluid pb-5 main-page container-fluid-limited">
    <div class="py-4">
        <saved-filter [pageTitle]="pageTitle" 
                      [dateInterval]="dateInterval" 
                      [selectedNamedFilter]="selectedFilter" 
                      (filterChange)="onFilterChange($event)"></saved-filter>
    </div>

    @if(report){
        @if(report.noDataYet){
            <div>
                <div class="col-md-8 mx-auto">
                    <div class="view_example_title">
                        <p>{{ 'reporting_no_data_yet' | translate}}</p>
                        <p>{{ 'reporting_no_data_yet_2' | translate}}</p>
                    </div>
                    <img src="/assets/images/view_examples/reporting_data_example.png" alt="reporting view example" class="reporting_view_example">
                </div>
            </div>
        }
        @else{
            <div class="reporting-grid">
                @if(report.people){
                <div class="reporting-grid-first-row bg-white">
                    <div>
                        <h3>{{ 'reporting_people' | translate}}</h3>
                        <help [content]="help.people"></help>
        
                        <div class="people row gx-5">
                            <div class="col-md-8">
                                <reporting-people [people]="report.people"></reporting-people>
                            </div>
                            <div class="col-md-4">
                                <p class="mb-1"><i class="fal fa-user-plus"></i>{{report.people.newComers}} {{ 'reporting_people_newcomers' | translate}}</p>
                                <p><i class="fal fa-user-slash"></i>{{report.people.recentlyDisabled}} {{ 'reporting_people_recently_disabled' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                }
                <div class="reporting-grid-second-row">
                    @if(report.participationRate){
                    <div class="participation-box bg-white">
                        <h3>{{ 'reporting_participation_rate' | translate}}</h3>
                        <div>
                            <div class="participation-box-global">
                                <h4>{{ 'reporting_participation_global' | translate}}</h4>
                                <help [content]="help.global"></help>
        
                                <i class="fal fa-envelope reporting-icon"></i>
                                <div class="text-center reporting-number">
                                    <p>{{ report.participationRate.current.value | number:'1.0-0'}}%</p>
                                    <p [ngStyle]="{ 'color': (report.participationRate.trend == 'positive') ? '#1c7d1c' : (report.participationRate.trend == 'negative') ? '#9a1010' : 'lightgrey'}"><small>{{ report.participationRate.tendencyDisplay }}</small></p>
                                    <p>
                                        <small>{{ 'reporting_participation_vs_prev' | translate}}</small>
                                    </p>
                                </div>
                                <p>{{ report.participationRate.current.actualParticipation }} {{ 'reporting_participation_mood_given' | translate}} {{ report.participationRate.current.possibleParticipation }} {{ 'reporting_participation_mood_possible' | translate}}</p>
                            </div>
                            <div class="participation-box-details">
                                <h4>{{ 'reporting_participation_distrib' | translate}}</h4>
                                <help [content]="help.participation"></help>
        
                                <div>
                                    <reporting-participation-details [chartData]="report.participationDistributionData"></reporting-participation-details>
                                </div>
                                <p>{{ 'reporting_participation_how_use' | translate}}</p>
                            </div>
                        </div>
                    </div>
                    }
                    @if(report.commentRate){
                    <div class="bg-white">
                        <h3>{{ 'reporting_commented' | translate}}</h3>
                        <help [content]="help.commented"></help>
        
                        <i class="fal fa-comments reporting-icon"></i>
                        <div class="text-center reporting-number">
                            <p>{{ report.commentRate.current.value | number:'1.0-0' }}%</p>
                            <p [ngStyle]="{ 'color': (report.commentRate.trend == 'positive') ? '#1c7d1c' : (report.commentRate.trend == 'negative') ? '#9a1010' : 'lightgrey'}"><small>{{ report.commentRate.tendencyDisplay }}</small></p>
                            <p>
                                <small>{{ 'reporting_participation_vs_prev' | translate}}</small>
                            </p>
                        </div>
                        <p>{{ report.commentRate.current.actualCommentsCount }} {{ 'reporting_commented_comments' | translate}} {{ report.commentRate.current.possibleCommentsCount }} {{ 'reporting_commented_mood_given' | translate}}</p>
                    </div>
                    }
                </div>
                <div class="reporting-grid-third-row">
                    @if(report.moodScore){
                    <div class="bg-white">
                        <h3>{{ 'reporting_score' | translate}}</h3>
                        <help [content]="help.score"></help>
        
                        <i class="fal fa-temperature-hot reporting-icon"></i>
                        <div class="text-center reporting-number">
                            <p class="reporting-number-moodscore">{{ report.moodScore.current.value | number:'1.0-1' }} <sub>/10</sub></p>
                            <p [ngStyle]="{ 'color': (report.moodScore.trend == 'positive') ? '#1c7d1c' : (report.moodScore.trend == 'negative') ? '#9a1010' : 'lightgrey'}"><small>{{ report.moodScore.tendencyDisplay }}</small></p>
                            <p>
                                <small>{{ 'reporting_participation_vs_prev' | translate}}</small>
                            </p>
                        </div>
                        <p>{{ 'reporting_score_average' | translate}} {{ report.moodScore.current.participation }} {{ 'reporting_commented_mood_given' | translate}}</p>
                    </div>
                    }
                    @if(report.moodDistributionData){
                    <div class="bg-white">
                        <h3>{{ 'reporting_mood_distrib' | translate}}</h3>
                        <help [content]="help.distribution"></help>
        
                        <div>
                            <reporting-mood-distribution [chartData]="report.moodDistributionData"></reporting-mood-distribution>
                        </div>
                        <p>{{ 'reporting_mood_distrib_desc' | translate}}</p>
                    </div>
                    }
                    @if(report.noteworthyDays){
                    <div class="bg-white">
                        <h3>{{ 'reporting_noteworthy_days' | translate}}</h3>
                        <help [content]="help.noteworthy"></help>
                        

                            <div class="bestDay milestoneDay">
                                @if(report.noteworthyDays.best){
                                    <p>
                                        <i class="fal fa-sun"></i>
                                        <span>{{'analytics.best_day' | translate}}: </span>
                                        <span>{{ report.noteworthyDays.best.date | date:'mediumDate' }}</span>
                                    </p>
                                    <div>
                                        <p>{{ 'reporting_noteworthy_days_score' | translate}} {{ report.noteworthyDays.best.score | number:'1.0-1' }} <small>/10</small></p>
                                        <p>{{ 'reporting_noteworthy_days_participation' | translate}} {{ report.noteworthyDays.best.participation }} {{ 'reporting_noteworthy_days_people' | translate}}</p>
                                    </div>
                                }
                            </div>
                            <div class="worstDay milestoneDay">
                                @if(report.noteworthyDays.worst){
                                    <p>
                                        <i class="fal fa-cloud-showers"></i>
                                        <span>{{'analytics.worst_day' | translate}}: </span>
                                        <span>{{ report.noteworthyDays.worst.date | date:'mediumDate' }}</span>
                                    </p>
                                    <div>
                                        <p>{{ 'reporting_noteworthy_days_score' | translate}} {{ report.noteworthyDays.worst.score | number:'1.0-1' }} <small>/10</small></p>
                                        <p>{{ 'reporting_noteworthy_days_participation' | translate}} {{ report.noteworthyDays.worst.participation }} {{ 'reporting_noteworthy_days_people' | translate}}</p>
                                    </div>
                                }
                            </div>
                            <p>{{ 'reporting_noteworthy_days_question' | translate}}</p>
                    </div>
                    }
                </div>
            </div>
        }
        
    }
    @else{
        <div class="text-center text-secondary pb-3">
            <i class="far fa-spinner fa-spin fa-2x"></i>
        </div>
    }
</main>